const customStyles = (maxPageSize) => ({
  container: (provided, state) => ({
    ...provided,
    height: '25px',
    width: '60px',
    border: state.selectProps.menuIsOpen ? '1px solid #463AD4' : '1px solid #EBEBEB',
    borderRadius: '4px',
    cursor: 'pointer',
    boxShadow: 'none',
    marginLeft: '12px',
    '&:hover': {
      borderColor: 'none',
    },
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '16px',
    height: '100%',
    border: 'none',
    cursor: 'pointer',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'none',
    },
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
    height: '100%',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
    width: '24px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '100%',
    overflow: 'initial',
    padding: '0',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#707070',
    fontFamily: 'Overpass',
    fontSize: '14px',
    lineHeight: '0px',
    overflow: 'initial',
    marginLeft: '5px',
  }),
  menu: (provided) => ({
    ...provided,
    padding: '8px',
    borderRadius: '4px 4px 0 0',
    boxShadow: '0px 0px 0px 2px rgba(214, 214, 214, 0.48), 0px 4px 8px rgba(133, 133, 133, 0.16)',
    width: maxPageSize ? '100px' : 'fit-content',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  option: (provided) => ({
    ...provided,
    fontFamily: 'Overpass',
    fontSize: '14px',
    cursor: 'pointer',
    backgroundColor: '#FFFFFF',
    color: '#474747',
    display: 'flex',
    justifyContent: maxPageSize ? 'start' : 'center',
    alignItems: 'center',

    '&:active': {
      backgroundColor: '#FFFFFF',
    },
    '&:hover': {
      backgroundColor: 'rgba(200, 195, 250, 0.48)',
      borderRadius: '4px',
    },
  }),
});
export default customStyles;
